import { createContext } from 'react';
import { useContext } from 'react';

const ZIndexContext = createContext(0);
const { Provider: ZIndexProvider } = ZIndexContext;

function useZIndex() {
  return useContext(ZIndexContext);
}

export { ZIndexProvider, useZIndex };
